import { render } from "./CartQuickAddModalWrapper.vue?vue&type=template&id=044ec628"
import script from "./CartQuickAddModalWrapper.vue?vue&type=script&lang=js"
export * from "./CartQuickAddModalWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__